module.exports = __webpack_public_path__ + "static/media/dm5.46b84526.svg";